module.exports = __webpack_public_path__ + "img/pg3_customer.221139b4.png";